import React from 'react';

export default function Historico({ movimentacoes }) {
  if (movimentacoes.length === 0) return <div className="mt"><span className="mt-ico">📋</span>Nenhuma movimentação registrada.</div>;

  return (
    <div className="lst">
      {movimentacoes.slice(0, 30).map((m) => (
        <div key={m.id} className="it">
          <div className="it-main">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span className={`bd ${m.tipo === 'entrada' ? 'bd-g' : 'bd-r'}`}>
                {m.tipo === 'entrada' ? 'Estoque' : 'Venda'}
              </span>
              <span style={{ fontSize: 11, color: 'var(--c4)' }}>{new Date(m.data).toLocaleString('pt-BR')}</span>
            </div>
            <div style={{ marginTop: 3 }}>
              <strong style={{ fontSize: 13 }}>{m.produto_nome}</strong>
              {m.cliente_nome && <span style={{ fontSize: 12, color: 'var(--c4)' }}> • {m.cliente_nome}</span>}
            </div>
          </div>
          <div style={{ textAlign: 'right', flexShrink: 0 }}>
            <span style={{ fontWeight: 700, fontSize: 13 }}>{m.quantidade}x</span>
            <span style={{ marginLeft: 6, fontSize: 12, fontWeight: 600, color: m.tipo === 'entrada' ? 'var(--y)' : 'var(--g)' }}>
              R$ {(m.quantidade * m.preco_unitario).toFixed(2)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
